import React from 'react';
import { GamePanelCard } from './GamePanelCard';

interface GameErrorCardProps {
  title: React.ReactNode;
  message: React.ReactNode;
  actionLabel: React.ReactNode;
  onAction: () => void;
  className?: string;
  titleClassName?: string;
  messageClassName?: string;
  actionClassName?: string;
}

export function GameErrorCard({
  title,
  message,
  actionLabel,
  onAction,
  className = '',
  titleClassName = 'text-sm',
  messageClassName = 'text-xs',
  actionClassName = 'text-sm',
}: GameErrorCardProps) {
  return (
    <GamePanelCard surface="panel" className={`text-center ${className}`.trim()}>
      <p className={`mb-2 font-semibold text-red-400 ${titleClassName}`.trim()}>{title}</p>
      <p className={`mb-4 text-brand-text/80 ${messageClassName}`.trim()}>{message}</p>
      <button type="button" onClick={onAction} className={`btn-secondary ${actionClassName}`.trim()}>
        {actionLabel}
      </button>
    </GamePanelCard>
  );
}
